"use strict";

exports.__esModule = true;
exports["default"] = SocialPinterestInverted;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function SocialPinterestInverted(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    viewBox: "0 0 512 512",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M256 421.8c-16.3 0-32.1-2.4-47-6.8 6.3-10 13.2-22.7 16.7-35.5 2.1-7.4 11.7-45.6 11.7-45.6 5.8 11 22.6 20.7 40.5 20.7 53.3 0 89.4-48.6 89.4-113.6 0-49.1-41.6-94.9-104.9-94.9-78.7 0-118.4 56.4-118.4 103.5 0 28.5 10.8 53.9 33.9 63.3 3.8 1.5 7.2.1 8.3-4.2.7-2.9 2.6-10.2 3.4-13.3 1.1-4.2.7-5.6-2.4-9.2-6.7-7.9-10.9-18.1-10.9-32.5 0-41.9 31.3-79.4 81.6-79.4 44.5 0 69 27.2 69 63.5 0 47.8-21.2 88.1-52.6 88.1-17.3 0-30.3-14.3-26.2-31.9 5-21 14.7-43.7 14.7-58.8 0-13.6-7.3-24.9-22.4-24.9-17.7 0-31.9 18.4-31.9 42.9 0 15.7 5.3 26.2 5.3 26.2s-18.1 76.9-21.3 90.3c-3 12.6-3.4 26.5-2.9 38.1-58.4-25.6-99.2-83.9-99.2-151.8 0-91.5 74.2-165.7 165.8-165.7C347.7 90.3 422 164.5 422 256c-.2 91.5-74.5 165.8-166 165.8z",
    fill: "#939496"
  }));
}